import {useCallback} from 'react'

import {useAppDispatch, useAppSelector} from '../../../../hooks/react-redux'
import {getErrorBySpotId} from '../EditPipelinePage/EditPipelinePage.selectors'
import {pipelineError} from '../EditPipelinePage/slices/EditPipelinePage.slices'
import {getValidationErrorMessage} from '../utils/validators'
import type {GetValidationErrorMessageProps} from '../utils/validators.types'

function useValidationErrorMessage(
  args: GetValidationErrorMessageProps,
  spotId: string,
  jobId?: string,
) {
  const dispatch = useAppDispatch()
  const {message: errorMessage} = useAppSelector(getErrorBySpotId(spotId))
  const handlerRemoveError = () => dispatch(pipelineError.actions.removeError(spotId))
  const handlerValidationError = useCallback(() => {
    const error = getValidationErrorMessage(args, spotId)

    if (error.id && !args.disabled) {
      dispatch(pipelineError.actions.addError({...error, jobId}))
    } else {
      dispatch(pipelineError.actions.removeError(spotId))
    }
  }, [args, dispatch, jobId, spotId])

  return {
    errorMessage,
    handlerValidationError,
    handlerRemoveError,
  }
}

export default useValidationErrorMessage
